import * as ActionTypes from '../constants/ActionTypes'

// **************************************************************************************************************
export const paymentStepReducer = (state = {isAlternateSepaInput: false}, action) => {

    switch (action.type) {

        case ActionTypes.ALTERNATE_SEPA_TOGGLE:

            return {isAlternateSepaInput: !state.isAlternateSepaInput}

        default:
            return state

    }

}



/** WEBPACK FOOTER **
 ** ./src/reducers/PaymentStep.js
 **/